import { jsx } from "react/jsx-runtime";
import { useRef, useContext, createContext, useState } from "react";
import { createPortal } from "react-dom";
import useIsomorphicLayoutEffect from "../../utils/useIsomorphicLayoutEffect.es.js";
import stitches from "../theme.config.es.js";
const PortalContext = createContext({
  current: null
});
const { Provider } = PortalContext;
const portalStyle = stitches.css({
  fontFamily: "$defaultFont"
});
const EzPortal = ({ children }) => {
  const mountNode = useRef(null);
  const { current: contextValue } = useContext(PortalContext);
  const contextRef = useRef(contextValue);
  const [hostNode, setHostNode] = useState(null);
  useIsomorphicLayoutEffect(() => {
    const { current: context } = contextRef;
    const parentElement = mountNode.current.ownerDocument === (context == null ? void 0 : context.ownerDocument) ? context : mountNode.current.ownerDocument.body;
    const { ownerDocument } = parentElement;
    const portalNode = ownerDocument.createElement("div");
    portalNode.classList.add(portalStyle());
    parentElement.appendChild(portalNode);
    setHostNode(portalNode);
    return () => {
      if (!parentElement.parentElement || !parentElement.contains(portalNode)) return;
      parentElement.removeChild(portalNode);
    };
  }, []);
  if (!hostNode) return /* @__PURE__ */ jsx("div", { ref: mountNode });
  return /* @__PURE__ */ jsx(Provider, { value: { current: hostNode }, children: createPortal(children, hostNode) });
};
export {
  PortalContext,
  EzPortal as default
};
//# sourceMappingURL=EzPortal.es.js.map
